import React from 'react';
import { ActivitySkeletonFilters } from '../skeleton-filters';
import { ActivitySkeletonContent } from '../skeleton-content';
import './style.scss';
import { FormattedMessage } from 'react-intl';

interface IProps {
  label: string;
}

export const ActivitySkeletonResult: React.FC<IProps> = ({ label }) => {
  return (
    <div className="activity-skeleton-wrapper">

      <p className="activity-skeleton-wrapper__text">
          <FormattedMessage id="searching.skeleton" />
      </p>
      
      
      <div className="activity-skeleton-wrapper__filters-top">
        <ActivitySkeletonFilters />
      </div>
      <div className="activity-skeleton-wrapper__content">
        <ActivitySkeletonContent label={label} />
      </div>
    </div>
  );
};
